import { Component, computed, inject, Input, OnInit } from '@angular/core';
import { InvestmentCategoriesService, ScopeService } from '../../../../@core/utils';
import { NbButtonModule, NbCardModule, NbDialogRef, NbDialogService } from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { InvestmentWizardService, WizardStep } from '../../../../@core/utils/investment-wizard-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { map, Observable, of, Subscription } from 'rxjs';

@Component({
  selector: 'app-investment-quick-edit',
  standalone: true,
  imports: [NbCardModule, CommonModule, NbButtonModule, TranslateModule],
  template: `
    <div class="wrapper">
      <nb-card>
        <nb-card-header class="d-flex py-3" style="min-height: 50px;">
          @if (showInvestmentCategoriesIcon$ | async) {
            <div (click)="toggleDisplay()" class="search-mode-button col-1">
              <img src="assets/icons/sitemap-light.svg" style="width: 1.8em" />
            </div>
          } @else {
            <div class="col-1"></div>
          }
          <div class="col-10 text-center fw-normal" style="color: #dc3545;">
            {{ step().label }}
          </div>
          <div class="col-1 justify-content-end text-align-right text-center fs-5 pointer" (click)="close()">
            <i class="fal fa-x"></i>
          </div>
        </nb-card-header>
        <nb-card-body>
          <ng-container *ngComponentOutlet="step().component"></ng-container>
        </nb-card-body>
      </nb-card>
    </div>`,
  styleUrls: ['../../side-forms/base-form/base-form.component.scss', 'wizard-index.component.scss'],
})
export class InvestmentWizardQuickEditComponent implements OnInit {

  @Input({required: true}) stepKey!: WizardStep['key']

  scope = inject(ScopeService);
  dialogRef = inject(NbDialogRef);
  dialogService = inject(NbDialogService);
  translate = inject(TranslateService);
  wizardService = inject(InvestmentWizardService);
  saveAndClose$: Subscription = null;
  investmentCategoriesService = inject(InvestmentCategoriesService);
  showInvestmentCategoriesIcon$: Observable<boolean> = of(false);

  step = computed(() => {
    const stepIdx = this.wizardService.getStepFromKey(this.stepKey),
      step = this.wizardService.stepsConfig[stepIdx];
    if (!step) throw new Error('Invalid step key for quick edit: ' + this.stepKey);
    return step;
  });

  ngOnInit() {
    this.saveAndClose$ = this.wizardService.saveAndClose$.subscribe(saveAndClose => {
      if (saveAndClose) {
        this.close();
      }
    });
    if (this.stepKey === 'INVESTMENT_CATEGORY_SELECTION') {
      this.showInvestmentCategoriesIcon$ = this.investmentCategoriesService.initInvestmentCategories(this.wizardService.existingInvestment)
      .pipe(
        map(({ sections, }) => {
          return sections.length > 1;
        })
      )
    }
  }

  close() {
    this.wizardService.saveAndClose$.next(false);
    this.saveAndClose$?.unsubscribe();
    this.dialogRef.close();
  }

  next() {
  }

  public toggleDisplay() {
    this.investmentCategoriesService.toggleDisplay();
  }
}
